// ✅ CustomiseTrip.js
import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/HomeLayout";
import axios from "axios";
import TripSlider from "../components/TripDetails/TripSlider";
import SiteReviews from "../components/SiteReviews";
import HomeBlogs from "../components/LandingPage/HomeBlogs";
import "../Style/CategoryListPage/Category.css";
import Form from "../components/Contact/Form";

// ✅ Import local static images
import banner1 from "../images/customisebanner1.jpg";
import banner2 from "../images/customisebanner2.jpg";
import banner3 from "../images/customisebanner3.jpg";
import banner4 from "../images/customisebanner4.jpg";

const CustomiseTrip = () => {
  const [trendingTrips, setTrendingTrips] = useState([]);

  useEffect(() => {
    const fetchTrips = async () => {
      try {
        const res = await axios.get("/api/trips/get-all-trips");
        const trips = res.data.data || [];

        const trendingCategories = [
          "Bali",
          "Thailand",
          "Maldives",
          "Kerala",
          "Spiti Valley",
          "Leh Ladakh",
          "Vietnam",
          "Georgia",
        ];

        const filtered = trips.filter((trip) =>
          trip.category?.some((cat) => trendingCategories.includes(cat))
        );

        // Shuffle once only
        const shuffled = filtered
          .map((trip) => ({ trip, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map(({ trip }) => trip);

        setTrendingTrips(shuffled);
      } catch (err) {
        console.error("Error fetching trips:", err);
      }
    };

    fetchTrips();
  }, []);

  const bannerImages = [banner1, banner2, banner3, banner4];

  return (
    <Layout>
      <div className="category-page customise-trip-page">
        {/* ===== Banner Section (same layout as CategoryPage) ===== */}
        <div className="category-banner container-fluid">
          <div className="banner-grid">
            {/* LEFT SIDE */}
            <div className="banner-left">
              <div className="banner-left-top">
                <img src={bannerImages[0]} alt="banner1" className="banner-img small" />
                <img src={bannerImages[1]} alt="banner2" className="banner-img small" />
              </div>
              <div className="banner-left-bottom">
                <img src={bannerImages[2]} alt="banner3" className="banner-img large" />
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="banner-right">
              <img src={bannerImages[3]} alt="banner4" className="banner-img big" />
              <div className="banner-reviews">
                <SiteReviews variant="slider" hideHeading={true} limit={5} />
              </div>
            </div>
          </div>
        </div>
{/* ===== Customise Trip Form Section (only for this page layout) ===== */}
{/* ===== Customise Trip Form Section ===== */}
<h2 className="plan-trip-heading text-center">Plan Your Trip</h2>

<div className="customise-trip-form-wrapper">
  <div className="customise-trip-form-left">
    <Form whiteBg={true} />
  </div>
  <div className="customise-trip-form-right">
    <img
      src="https://images.pexels.com/photos/287240/pexels-photo-287240.jpeg?cs=srgb"
      alt="Beautiful Destination"
      className="customise-trip-side-image"
    />
  </div>
</div>


        {/* ===== Trending Trips Section ===== */}
        <section className="py-5 container">
          <h2 className="fw-bold mb-4 text-center">Trending Trips</h2>
          {trendingTrips.length > 0 ? (
            <TripSlider trips={trendingTrips} />
          ) : (
            <p className="text-center">No trending trips available</p>
          )}
        </section>

        {/* ===== Site Reviews Section ===== */}
        <SiteReviews limit={6} variant="grid" showButton={true} />

      
      </div>
            <HomeBlogs />
      
    </Layout>
  );
};

export default CustomiseTrip;
